define(function (require) {
	const ViewManager = require('civicsUtils/view_manager');
	const tpl = require('civicsViews/send_email/templates/t_itv_email.hbs');
	const AvailableFeatures = require('civicsUtils/available_features');

	return Marionette.ItemView.extend({
		initialize: function (options) {
			this.index = options.index;
			this.allowEmptyData = options.allowEmptyData;
		},
		template: tpl,
		tagName: 'div',
		className: 'email-item list-row',
		attributes: {
			'role': 'row'
		},
		events: {
			'focus @ui.emailField': 'onEmailFocus',
			'focusout @ui.emailField': 'onEmailFocusOut',
			'click @ui.removeButton': 'removeEmailItem',
			'keyup @ui.emailField': 'onEmailFieldChange',
		},
		ui: {
			emailField: '.send-to .input-text',
			headerEmailAddress: '.header-email-address',
			headerDelete: '.header-delete',
			removeButton: '.remove-email'
		},
		onShow: function () {
		},
		onRender: function () {
			if (!this.model.get('showDelete')) {
				if (this.ui.headerEmailAddress != undefined)
					this.ui.headerEmailAddress[0].style.width = '100%';
				if (this.ui.headerDelete != undefined)
					this.ui.headerDelete.hide();
			}

			if (this.ui.emailField) {
				//this.ui.emailField[0].name += this.model.get('id')
				this.emailFieldName = this.ui.emailField[0].name;
				this.ui.emailField[0].setAttribute('autocomplete', 'nope');
			}
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();
		},
		onEmailFocus: function () {
			if (this.ui.emailField) {
				this.ui.emailField[0].setAttribute('autocomplete','email');
			}
		},
		onEmailFocusOut: function () {
			if (this.ui.emailField) {
				this.ui.emailField[0].setAttribute('autocomplete', 'nope');
			}
		},
		onEmailFieldChange: function () {
			var state = this.isEmailFieldEmpty() ? true : false;
			this.triggerMethod('email-item:onEmailFieldChange', state);
		},
		isEmailFieldEmpty: function () {
			var field = this.ui.emailField.val();
			return (field.trim().length === 0 || field <= 0);
		},
		getData: function () {
			var self = this;
			var data = Backbone.Syphon.serialize(self);
			var error = {};
			error.validationError = {};

			var emailCollection = data[this.emailFieldName].split(',');
			if (emailCollection) {
				var invalidEmailCount = emailCollection.length;
				_.forEach(emailCollection, email => {
					if (self.isEmailValid(email.trim()))
						invalidEmailCount--;
				});

				data.isValid = invalidEmailCount == 0 ? true : false;
				data.emailAddressCollection = emailCollection;
			}

			if (!data.isValid) {
				error.validationError[this.emailFieldName] = i18n.t('CIVICS.COMMON.INVALID_EMAIL');
				ViewManager.errorToWindow(error, self);
			}

			return data;
		},
		isEmailValid: function (email) {
			var self = this;
			if (self.allowEmptyData && !email)
				return true;

			var emailRegex = (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
			if (!emailRegex.test(email)) {
				return false;
			}

			return true;
		},
		removeEmailItem: function () {
			this.triggerMethod('email-item:remove');
		},
		templateHelpers: function () {
			var self = this;
			return {
				sendTo: self.model.emailAddress,
				maxEmailLength: AvailableFeatures.MaxEmailLength(),
				index: self.index
			}
		},
	});
});
